module.exports = __webpack_public_path__ + "static/media/osmolarity-calculator.f144b977.gif";